var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('D3LineChart',{attrs:{"forDashboard":true,"statMode":_vm.statMode,"seriesData":_vm.seriesData,"series":_vm.series},on:{"updateStatMode":_vm.updateStatMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }